<tt-page *ngIf="!!setting">
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <ng-container *ngTemplateOutlet="selectionCriterias"></ng-container>
        </tt-card>

        <tt-list [ttData]="itemsListCompanies"></tt-list>
    </div>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-divider ttRememberId="brreg_dividers">
            <tt-divider-columns>
                <tt-divider-pane ttSize="30">
                    <tt-card class="col-xs-12 p-5">
                        <ng-container *ngTemplateOutlet="selectionCriterias"></ng-container>
                    </tt-card>
                </tt-divider-pane>

                <tt-divider-pane ttSize="70">
                    <tt-list class="col-xs-12 p-5" [ttData]="itemsListCompanies"></tt-list>
                </tt-divider-pane>
            </tt-divider-columns>
        </tt-divider>
    </div>
</tt-page>

<ng-template #selectionCriterias>
    <ng-container *ngIf="!!setting">
        <form class="form-horizontal sp-0" name="formCompanySearch" novalidate (ngSubmit)="searchItems()" method="get" role="form">
            <tt-input ttLabel="companyname_search" [(ttModel)]="setting.companyname_search" [ttButtons]="companyNameButtons"></tt-input>
        </form>

        <tt-select ttLabel="naeringskode" [(ttModel)]="setting.naeringskode" [ttData]="selectListNaces" ttDataId="nace_id" ttDataName="nace_name" [ttButtons]="naeringsKodeButtons"></tt-select>
        <tt-input ttLabel="naeringskode" [(ttModel)]="setting.naeringskode" [ttButtons]="naeringsKodeEditButtons"></tt-input>
        <tt-select ttLabel="county" [(ttModel)]="setting.county_id" (ttModelChange)="onChanged($event, 'county_id')" [ttData]="selectListCounties" ttDataId="county_id" ttDataName="county_name" [ttButtons]="countyButtons"></tt-select>
        <tt-select [hidden]="setting.county_id === ''" ttLabel="comunity" [(ttModel)]="setting.comunity_id" [ttData]="selectListCommunities" ttDataId="comunity_id" ttDataName="comunity_name" [ttButtons]="communityButtons"></tt-select>
        <tt-input-number ttLabel="fraAntallAnsatte" [(ttModel)]="setting.fraAntallAnsatte" ttTextAlign="right" ttFormatNumber ttDecimals></tt-input-number>
        <tt-button ttText="brreg_execute_call" (ttClick)="getUrl()" [ttSpin]="loadingCompanies" ttIcon="fas fa-sync"></tt-button>
    </ng-container>
</ng-template>
